<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goBack()">{{ 'customerAddressUpdate.buttons.back' | translate }}</button>
    </app-page-header>
    <div class="setting-data">
      <div class="second-headboard">
        <h1>{{ 'customerAddressUpdate.title' | translate }}</h1>
        <!-- <img src="../../assets/icons/1234.png" alt="logo de Billcentrix"> -->

      </div>
      <div class="general-data">
        <h1>{{ 'customerAddressUpdate.generalData' | translate }}</h1>
        <form [formGroup]="form" >
          <div class="grid">
            <div class="left">

              <!-- <div class="items">
              <label for="country">Provincia*</label>
              <div class="select-wrapper">
                <select (change)="onProvinceChange()" [formControl]="form.controls['province']">
                  <option   selected="" value="">Seleccione un opción</option>
                  <option *ngFor="let p of provinces" [value]="p.id" >{{p.name}}</option>
                </select>
                <i class="arrow"></i>
                <small  *ngIf="form.controls['province'].hasError('required') && form.controls['province'].touched"
                  class="form-error-msg"> Provincia es requerido
                </small>
              </div>
            </div> -->

            <div class="items">
              <label for="name">{{ 'customerAddressUpdate.fields.address' | translate }}*</label>
              <input [formControl]="form.controls['adress']"
                type="text" placeholder="{{ 'customerAddressUpdate.fields.addressPlaceholder' | translate }}">
                @if (form.controls['adress'].hasError('required') &&
                  form.controls['adress'].touched) {
                  <small
                  class="form-error-msg"> {{ 'customerAddressUpdate.fields.addressError' | translate }}</small>
                }
              </div>

            </div>
            <div class="right">
              <!-- <div class="items">
              <label >Corregimiento*</label>
              <div class="select-wrapper">
                <select [formControl]="form.controls['corregimiento']" id="corregimiento" name="corregimiento">
                  <option   selected="" value="">Seleccione un opción</option>
                  <option *ngFor="let c of corregimientos" [value]="c.id" >{{c.name}}</option>
                </select>
                <i class="arrow"></i>
                <small  *ngIf="form.controls['corregimiento'].hasError('required') && form.controls['corregimiento'].touched"
                  class="form-error-msg"> Corregimiento es requerido
                </small>
              </div>
            </div> -->
            <div class="items">
              <label for="name">{{ 'customerAddressUpdate.fields.phone' | translate }}*</label>
              <input (keypress)="onlyNumberKey($event)"  [formControl]="form.controls['phone']"
                type="tel" placeholder="{{ 'customerAddressUpdate.fields.phonePlaceholder' | translate }}" autocomplete="tel">
                @if (form.controls['phone'].hasError('required') &&
                  form.controls['phone'].touched) {
                  <small
                  class="form-error-msg"> {{ 'customerAddressUpdate.fields.phoneError' | translate }}</small>
                }
                @if (form.controls['phone'].hasError('pattern') &&
                  form.controls['phone'].touched) {
                  <small
                  class="form-error-msg"> {{ 'customerAddressUpdate.fields.phonePatternError' | translate }}</small>
                }
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>


    <div class="options-buttons">
      <button class="back-btn" (click)="goBack()" >{{ 'customerAddressUpdate.buttons.cancel' | translate }}</button>
      <button   class="continue-btn" (click)="update()" >{{ 'customerAddressUpdate.buttons.save' | translate }}</button>
    </div>
  </div>
</body>
